/**
 * This module is a fork of and modifies:
 * https://github.com/necolas/react-native-web
 *
 * The original source is (c) Nicolas Gallagher
 * and licensed under the MIT license found a
 * https://github.com/necolas/react-native-web/blob/master/LICENSE
 */
const CSS_UNIT_RE = /^[+-]?\d*(?:\.\d+)?(?:[Ee][+-]?\d+)?(%|\w*)/

const getUnit = (str: string) => {
  const matches = str.match(CSS_UNIT_RE)
  if (!matches) {
    return null
  }
  return matches[1]
}

const isNumeric = (n: string | number) => {
  return !Number.isNaN(parseFloat(n as string)) && Number.isFinite(n as number)
}

const multiplyStyleLengthValue = (value: string | number, multiple: number) => {
  if (typeof value === "string") {
    const number = parseFloat(value) * multiple
    const unit = getUnit(value)
    return `${number}${unit}`
  }
  if (isNumeric(value)) {
    return value * multiple
  }
  return undefined
}

export default multiplyStyleLengthValue
